import axios from 'axios';

export const httpClient = axios.create({
    responseType: 'json',
    responseEncoding: 'utf8',
    adapter: 'fetch',
});
